export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új engedély',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        rowActions: [
            {
                btn_text: 'Validálás',
                title: 'Validálás',
                event_name: "customClick",
                class: "btn btn-outline-teal",
                event_payload: 'showValidatePopup',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-history"></i>',
                title: 'Előzmények',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'showHistory'
            },
            {
                btn_text: '<i class="far fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'edit',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-unlock"></i>',
                title: 'Felnyitás',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeEdit',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
            },
        ],
        headerFields: [
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true,
                formType: "date"
            },
            {
                name: "level.text",
                label: "Fok",
                visibility: true
            },
            {
                name: "driverLicenseType.text",
                label: "Vezetői engedély típus",
                visibility: true
            },
            {
                name: "opinionType.text",
                label: "Vélemény típus",
                visibility: true
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true
            },
            {
                name: "nextExaminationDate",
                label: "Következő vizsgálat",
                slot_name: "date_format",
                sort: true,
                visibility: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                sort: true,
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
